var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LabeledInput',{model:{value:(_vm.value.foo),callback:function ($$v) {_vm.$set(_vm.value, "foo", $$v)},expression:"value.foo"}})}
var staticRenderFns = []

export { render, staticRenderFns }